import { render, staticRenderFns } from "./TqCreditCardsList.vue?vue&type=template&id=2add4b5b&scoped=true&"
import script from "./TqCreditCardsList.vue?vue&type=script&lang=js&"
export * from "./TqCreditCardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2add4b5b",
  null
  
)

export default component.exports